import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import { formatDateTime } from '../utils/dateutils';
import dayjs from 'dayjs';

import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
// Function to convert date to day (Monday, Tuesday, etc.)
const getDayName = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { weekday: 'long' });
};


// Function to format date as YYYY-MM-DD
const formatDate = (dateString) => {
  
    return dayjs.utc(dateString).format("YYYY-MM-DD"); // Extract YYYY-MM-DD
};

const WeekTable = ({ tableData }) => {
    const navigate = useNavigate();
  
    // Initialize an object to group records by supervisor's full name
    const supervisorData = {};

    // Populate supervisorData with records
    tableData.forEach((supervisor) => {
        const supervisorFullName = `${supervisor.firstname} ${supervisor.lastname}`;
    
        if (!supervisorData[supervisorFullName]) {
            supervisorData[supervisorFullName] = { supervisorFullName, dates: {} };
        }
        supervisor.records.forEach((record) => {
            const date = formatDate(record.clock_in);

            if (!supervisorData[supervisorFullName].dates[date]) {
                supervisorData[supervisorFullName].dates[date] = [];
            }

            supervisorData[supervisorFullName].dates[date].push({
                company: record.company_name,
                entries: record.entries,
                status: record.overall_status,
                companyid: record.companyid,
            });
        });
    });

    // Convert supervisorData to an ordered list
    const formattedData = Object.values(supervisorData);

    return (
        <div className="w-full max-w-full overflow-x-auto custom-scrollbar rounded-[10px] border"
            style={{ boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.25)' }}
        >
            <table className="w-full min-w-[1000px]  rounded-[20px]">
                <thead>
                    <tr className="border  bg-[#F9FAFB] text-[#900]">
                        <th className="p-3 font-inter font-normal w-[5%] text-start">Supervisor</th>
                        <th className="p-3 font-inter font-normal w-[8%] text-start">Date</th>
                        <th className="p-3 font-inter font-normal w-[15%] text-start">Company</th>
                        <th className="p-3 font-inter font-normal w-[10%] text-center">Active Entries</th>
                        <th className="p-3 pl-8 font-inter font-normal w-[10%] text-start">Status</th>
                    </tr>
                </thead>
                <tbody>
  {formattedData.length === 0 ? (
    <tr>
      <td colSpan={5} className="text-center p-4 text-gray-500">
        No data found
      </td>
    </tr>
  ) : (

  formattedData.map((row, index) => {
    const dateKeys = Object.keys(row.dates);
    let supervisorRowSpan = 0;
    dateKeys.forEach((date) => {
      supervisorRowSpan += row.dates[date].length;
    });

    return (
      <React.Fragment key={index}>
        {dateKeys.map((date, dateIndex) => {
          console.log(date,'jhlik')
          const companies = row.dates[date];
      
          return companies.map((company, companyIndex) => (
            <tr key={`${date}-${companyIndex}`} className="bg-[#FFF]">
              {/* Supervisor column: show only for the first company of the first date */}
              {dateIndex === 0 && companyIndex === 0 && (
                <td
                  rowSpan={supervisorRowSpan}
             className="p-3 text-start font-inter text-[14px] font-normal border-t align-top"
                >
                  {row.supervisorFullName}
                </td>
              )}

              {/* Date column: show only for the first company of each date */}
              {companyIndex === 0 && (
                <td
                  rowSpan={companies.length}
                  className="p-3 text-sm font-inter text-[#111827] text-start border border-[#E4E4E7] border-b-0 "
                >
              {dayjs.utc(date).format('DD MMM, YYYY')}
                </td>
              )}

              {/* Company */}
              <td className="p-3 text-xs font-inter text-[#374151] text-start border border-[#E4E4E7] border-b-0 border-l-0 border-r-0">
                {company.company}
              </td>

              {/* Number of Entries */}
              <td className="p-3 py-4 text-center border border-[#E4E4E7] border-b-0 border-l-0 border-r-0">
                {company.entries}
              </td>

              {/* Status and View */}
              <td
                className={`p-3 text-start border border-[#E4E4E7] border-b-0 border-l-0 border-r-0 ${
                  company.status === "Submitted" ? "text-[#15803D]" : "text-[#D97706]"
                }`}
              >
                <div className="flex justify-between">
                <div
  className={`inline-block text-xs font-inter rounded-full text-sm px-2 py-1 text-center ${
    company.status === "SUBMITTED"
      ? "bg-[#DCFCE7] text-green-800 min-w-[90px]"
      : company.status === "DELETED"
      ? "bg-gray-200 text-gray-500 min-w-[90px]"
      : "bg-[#FEF9C3] min-w-[90px]"
  }`}
>
  {company.status === "DELETED" ? "-" : company.status}
</div>

                  <div
                    className="text-[#8B1818] text-sm font-semibold cursor-pointer mr-4"
                    onClick={() => {
                      const [firstName, lastName] = row.supervisorFullName.split(' ');
                    
                      const matchedSupervisor = tableData.find(
                        item => item.firstname === firstName && item.lastname === lastName
                      );
                      console.log('matched',company)
                      if (matchedSupervisor) {
                        // const companyid = matchedSupervisor.records[0]?.companyid;
                        const supervisorid = matchedSupervisor.supervisorid;
                        
                        navigate(
                          `/timesheet?companyid=${company.companyid}&supervisorid=${supervisorid}&date=${date}&&company=${company.company}`
                        );
                      } else {
                        console.warn('Supervisor not found in tableData');
                      }
                    }}
                  >
                    View
                  </div>
                </div>
              </td>
            </tr>
          ));
        })}
      </React.Fragment>
    );
  })
  )}
</tbody>

            </table>
        </div>
    );
};

export default WeekTable;
